// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { removeUser } from "store/authSlice";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api",

  prepareHeaders: (headers, { getState }) => {
    const user = getState().auth.user;

    if (user)
      headers.set("authorization", [
        `Bearer ${user.token}`,
        user.viewEntity && `viewEntity ${user.viewEntity.entity._id}`,
        user.viewEntity && `currentRole ${user.viewEntity.authorization._id}`,
      ]);

    return headers;
  },
});

// Define a service using a base URL and expected endpoints
export const baseApi = createApi({
  tagTypes: [
    "Account",
    "AccountList",
    "Admin",
    "Collection",
    "Application",
    "Authorization",
    "Blog",
    "Broadcast",
    "Branch",
    "Client",
    "ClientPortal",
    "Course",
    "CoursePricing",
    "Country",
    "Dashboard",
    "District",
    "Municipality",
    "Region",
    "DynamicForm",
    "Entity",
    "Feedback",
    "GlobalList",
    "Issue",
    "Inquiry",
    "Knowledgebase",
    "Lead",
    "List",
    "MarketingCampaign",
    "Monitoring",
    "Notification",
    "Partnership",
    "Public",
    "Report",
    "Search",
    "Staff",
    "Status",
    "Step",
    "StudyOption",
    "Question",
    "Questionnaire",
    "Task",
    "Team",
    "Ticket",
    "Transaction",
    "University",
    "User",
    "Workflow",
    "WorkflowTransaction",
    "Warehouse",
    "Insurance",
    "Contract",
    "Driver",
    "VehicleMaintenance",
    "Vehicle",
    "DriverLicence",
    "DataIntegration",
    "Customer",
    "ShipmentFD",
    "Shipment",
    "Transshipment",
    "Vendor",
    "CrossDocking",
    "Communication",
    "Compliance",
    "MapAddress",
    "ShipmentLoading",
    "Freeloading",
    "ShipmentUnLoading",
    "RouteShipment",
    "Leg",
    "Consolidation",
    "Delivery",
    "Warehousing",
    "COCCollection",
    "SendOut",
    "SendOutCollection",
    "Note",
    "Prepayment",
    "Adjustment",
    "CODTransfer",
    "DeliveryCollection",
    "VehicleFuel",
    "Search",
    "Role",
    "Merchant",
    "Announcement",
    "SmsProvider",
    "SmsTemplate",
    "SmsIntegration",
    "ShipmentMessages",
    "VendorReport",
    "BranchReport",
    "DriverRouteAssignment",
    "LocalTransport",
    "LocalTransportRule",
    "GeneralLedger",
    "EBillProvider",
    "ShipmentRefund",
    "BranchShipmentLocation",
    "RoadClosure",
  ],

  reducerPath: "baseApi",

  baseQuery: async (args, api, extraOptions) => {
    const result = await rawBaseQuery(args, api, extraOptions);

    if (result.error?.status === 401 && api.endpoint !== "login") {
      api.dispatch(removeUser());
    }

    return result;
  },

  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/users/login",
        method: "POST",
        body: credentials,
      }),
    }),
  }),
});

export const { useLoginMutation } = baseApi;
